<template>
  <div class="password-recovery-code">
    <v-container fill-height>
      <v-layout
        row
        wrap
        fill-height
      >
        <v-flex
          class="py-0"
          xs12
        >
          <h1>{{ $t('app.login.PasswordRecoveryCode.title') }}</h1>
        </v-flex>
        <v-flex
          class="py-2"
          xs12
        >
          <span class="subtitle">{{ $t('app.login.PasswordRecoveryCode.subtitle') }}</span>
        </v-flex>
        <v-flex
          class="py-2"
          xs10
          mx-auto
        >
          <pincode-input
            v-model="code"
            :length="5"
            autofocus
            class="d-flex justify-space-between"
          />
        </v-flex>
        <v-flex
          class="py-0"
          xs8
          mx-auto
        >
          <btn-primary
            id="continueCodeButton"
            block
            :text="$t('app.login.PasswordRecoveryCode.continue')"
            :disabled="!canContinue"
            @click="submitCode()"
          />
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import PincodeInput from 'vue-pincode-input';
import BtnPrimary from 'Support/components/buttons/BtnPrimary.vue';
import PageableMixin from 'Support/components/lists/mixins/pageable.mixin';

export default {
  name: 'PasswordRecoveryCode',
  components: {
    PincodeInput,
    BtnPrimary,
  },
  mixins: [PageableMixin],
  data: () => ({
    code: '',
  }),
  computed: {
    canContinue() {
      return this.code.length === 5;
    },
  },
  methods: {
    submitCode() {
      this.$emit('input', this.code);
    },
  },
};
</script>

<style lang="stylus" scoped>
  .password-recovery-code
    h1
      font-style normal
      font-weight bold
      font-size 36px
      line-height 39px
      color #113752
    .subtitle
      font-style normal
      font-weight normal
      font-size 14px
      color #113752
</style>
